import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { CombinationPrevention } from '../../../../../core/picks/combo-prevention';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates Betbuilder and V2 paricipant pick if they are compatible for combo.
 */
export class BetbuilderV2ParticipantComboPrevention extends BaseComboPrevention<BetslipBetBuilderPick, BetslipV2ParticipantPick> {
    constructor() {
        super(BetslipBetBuilderPick, BetslipV2ParticipantPick);
    }

    validate(thisPick: BetslipBetBuilderPick, otherPick: BetslipV2ParticipantPick): ComboPreventionResult {
        if (thisPick.market.comboPrevention === CombinationPrevention.NoCombo) {
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}
